<template>
  <div class="extension-data flex align-items">
    <div class="item">
      <p class="number">{{acceptNum}}</p>
      <p class="number" v-if="!acceptNum">0</p>
      <p class="text">已接单</p>
    </div>
    <div class="item">
      <p class="number">{{successNum}}</p>
      <p class="number" v-if="!successNum">0</p>
      <p class="text">已达标</p>
    </div>
    <div class="item">
      <p class="number">{{failNum}}</p>
      <p class="number" v-if="!failNum">0</p>
      <p class="text">未达标</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExtensionData',
  props: {
    acceptNum: String,
    successNum: String,
    failNum: String
  },
  methods: {
    routerTo () {
      this.$router.push({name: 'Release', query: { userId: 123 }})
    }
  }
}
</script>
<style scoped>
  .extension-data .item{width: 100px; text-align: center;}
  .extension-data .item .number{font-size:36px;}
  .extension-data .item .text{color:#999;margin-top:2px;}
  .extension-data .item:nth-child(3){margin-right:10px;}
</style>
